import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Sitemap", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " Deze sitemap pagina toont een overzicht van de op deze website beschikbare pagina's. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_q_separator, { color: "primary" }),
          _hoisted_4,
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: { name: 'bro-monitor' } }, {
                default: _withCtx(() => [
                  _createTextVNode(" Home")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: { name: 'bro-monitor-archive' } }, {
                default: _withCtx(() => [
                  _createTextVNode(" Archief")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: { name: 'gegevens-per-bronhouder' } }, {
                default: _withCtx(() => [
                  _createTextVNode(" Download gegevens per bronhouder")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: { name: 'cookies_privacy' } }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cookies en privacy")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: { name: 'kwetsbaarheid-melden' } }, {
                default: _withCtx(() => [
                  _createTextVNode(" Kwetsbaarheid-melden")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: { name: 'overdebromonitor' } }, {
                default: _withCtx(() => [
                  _createTextVNode(" Over de BRO Monitor")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: { name: 'toegankelijkheid' } }, {
                default: _withCtx(() => [
                  _createTextVNode(" Toegankelijkheid")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}